export const getFuelCardTitle = tankkart => {
  const providers = tankkart.uds_providercode?.attributeValue
    ? tankkart.uds_providercode?.attributeValue.map(provider => provider.label).join(', ')
    : '';
  return `${providers} (${tankkart.uds_nummer?.attributeValue || 'keine Tankkartennummer'})`;
};
